import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("ConsentDocuments")
export class ConsentDocuments implements AxInit {
    checkBoxInfos: ICheckboxInfo[] = [];
    consentNeeded: boolean = false;

    AxInit(init): void {
        $('.input-consent-doc-checkbox').change(() => {
            this.evaluateConentDocCheckBoxes();
        });
    }

    evaluateConentDocCheckBoxes() {
        this.checkBoxInfos = [];

        $(".input-consent-doc-submit-button").prop('disabled', false);
        $('.input-consent-doc-checkbox').each((index, element) => {
            this.consentNeeded = true;
            let consentDoc = {
                documentId: $(element).attr('id'),
                isChecked: false
            }
            if ($(element).hasClass('input-consent-doc-checkbox-mandatory') && !$(element).is(':checked')) {
                $(".input-consent-doc-submit-button").prop('disabled', true);
            }

            if ($(element).is(':checked')) {
                consentDoc.isChecked = true;
            } else {
                consentDoc.isChecked = false;
            }

            this.checkBoxInfos.push(consentDoc);
        });
    }

    getActiveCheckboxes(): ICheckboxInfo[] {
        return this.checkBoxInfos;
    }

    getConsentNeeded(): boolean {
        return this.consentNeeded;
    }
}

export interface ICheckboxInfo {
    documentId: string;
    isChecked: boolean;
}